<template>
  <section class="cta-section">
    <div class="cta-container">
      <div class="cta-content">
        <div class="cta-header">
          <div class="section-badge">
            <i class="fas fa-rocket"></i>
            <span>立即行动</span>
          </div>
          <h2 class="cta-title">准备好与我们一起探索AI的无限可能了吗？</h2>
        </div>
        <p class="cta-description">
          弦动魔方科技致力于为客户提供全方位的AI解决方案，从模型训练到硬件研发，满足您的各种智能化需求。未来，我们将持续创新，为社会创造更多具有实际价值的科技成果，真正实现科技造福群众的宏伟愿景。
        </p>
        <div class="cta-actions">
          <button class="button button-primary">
            <span class="button-content">联系我们</span>
            <span class="button-icon"><i class="fas fa-arrow-right"></i></span>
            <span class="button-glow"></span>
          </button>
          <button class="button button-secondary">
            <span class="button-content">了解更多</span>
            <span class="button-icon"><i class="fas fa-info-circle"></i></span>
          </button>
        </div>
        
        <div class="advantage-chips">
          <div class="chip">
            <i class="fas fa-shield-alt"></i>
            <span>安全可靠</span>
          </div>
          <div class="chip">
            <i class="fas fa-tachometer-alt"></i>
            <span>高效服务</span>
          </div>
          <div class="chip">
            <i class="fas fa-chart-line"></i>
            <span>持续创新</span>
          </div>
          <div class="chip">
            <i class="fas fa-handshake"></i>
            <span>专业团队</span>
          </div>
        </div>
      </div>
      
      <div class="cta-visual">
        <div class="tech-sphere">
          <div class="sphere-core"></div>
          <div class="sphere-ring"></div>
          <div class="sphere-ring ring-2"></div>
          <div class="sphere-particle p1"></div>
          <div class="sphere-particle p2"></div>
          <div class="sphere-particle p3"></div>
          <div class="sphere-particle p4"></div>
        </div>
      </div>
    </div>
    
    <div class="floating-particles">
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
    </div>
    
    <div class="cta-background">
      <div class="gradient-blob blob-1"></div>
      <div class="gradient-blob blob-2"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CtaSection'
}
</script>

<style scoped>
.cta-section {
  position: relative;
  padding: 8rem 0;
  background-color: #181425;
  overflow: hidden;
  min-height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cta-container {
  position: relative;
  display: flex;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  gap: 4rem;
  z-index: 2;
}

.cta-content {
  flex: 1;
  max-width: 650px;
}

.cta-header {
  margin-bottom: 1.5rem;
}

.section-badge {
  display: inline-flex;
  align-items: center;
  background: rgba(157, 110, 253, 0.15);
  padding: 0.5rem 1rem;
  border-radius: 50px;
  margin-bottom: 1.5rem;
  border: 1px solid rgba(157, 110, 253, 0.3);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.section-badge i {
  color: #9D6EFD;
  margin-right: 0.5rem;
}

.section-badge span {
  color: #ffffff;
  font-weight: 600;
  font-size: 0.9rem;
}

.cta-title {
  font-size: 3rem;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 1.5rem;
  background: linear-gradient(135deg, #ffffff 0%, #b59eff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.cta-description {
  font-size: 1.1rem;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 2.5rem;
}

.cta-actions {
  display: flex;
  gap: 1rem;
  margin-bottom: 2.5rem;
}

.button {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 2rem;
  border-radius: 50px;
  font-size: 1.1rem;
  font-weight: 600;
  border: none;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s ease;
}

.button-content {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.button-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 0.75rem;
  transition: transform 0.3s ease;
}

.button-primary {
  background: linear-gradient(135deg, #9D6EFD 0%, #E879F9 100%);
  color: white;
  box-shadow: 0 4px 25px rgba(157, 110, 253, 0.4);
}

.button-primary:hover {
  box-shadow: 0 6px 30px rgba(157, 110, 253, 0.6);
  transform: translateY(-3px);
}

.button-primary:hover .button-icon {
  transform: translateX(5px);
}

.button-glow {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(157, 110, 253, 0.4) 0%, rgba(232, 121, 249, 0.4) 100%);
  filter: blur(20px);
  z-index: 1;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.button-primary:hover .button-glow {
  opacity: 1;
}

.button-secondary {
  background: rgba(255, 255, 255, 0.05);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.button-secondary:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-3px);
}

.advantage-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.chip {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 50px;
  font-size: 0.9rem;
  color: white;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.chip:hover {
  background: rgba(157, 110, 253, 0.1);
  border-color: rgba(157, 110, 253, 0.3);
  transform: translateY(-2px);
}

.chip i {
  color: #9D6EFD;
}

.cta-visual {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.tech-sphere {
  position: relative;
  width: 280px;
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sphere-core {
  width: 80px;
  height: 80px;
  background: radial-gradient(circle, rgba(232, 121, 249, 0.8) 0%, rgba(157, 110, 253, 0.8) 100%);
  border-radius: 50%;
  box-shadow: 0 0 30px rgba(157, 110, 253, 0.6);
  animation: pulseCore 4s ease-in-out infinite alternate;
}

.sphere-ring {
  position: absolute;
  width: 180px;
  height: 180px;
  border: 2px solid rgba(157, 110, 253, 0.3);
  border-radius: 50%;
  animation: rotateRing 15s linear infinite;
}

.sphere-ring.ring-2 {
  width: 240px;
  height: 240px;
  border-color: rgba(232, 121, 249, 0.3);
  animation-duration: 20s;
  animation-direction: reverse;
}

.sphere-particle {
  position: absolute;
  width: 20px;
  height: 20px;
  background: #9D6EFD;
  border-radius: 50%;
  box-shadow: 0 0 15px rgba(157, 110, 253, 0.8);
}

.sphere-particle.p1 {
  top: 20%;
  left: 10%;
  animation: orbitParticle 12s linear infinite;
}

.sphere-particle.p2 {
  top: 70%;
  right: 15%;
  width: 15px;
  height: 15px;
  background: #E879F9;
  animation: orbitParticle 15s linear 2s infinite reverse;
}

.sphere-particle.p3 {
  bottom: 25%;
  left: 20%;
  width: 12px;
  height: 12px;
  background: #9D6EFD;
  animation: orbitParticle 18s linear 4s infinite;
}

.sphere-particle.p4 {
  top: 30%;
  right: 20%;
  width: 10px;
  height: 10px;
  background: #E879F9;
  animation: orbitParticle 10s linear 3s infinite reverse;
}

.floating-particles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.particle {
  position: absolute;
  width: 6px;
  height: 6px;
  background: #9D6EFD;
  border-radius: 50%;
  opacity: 0.6;
  animation: floatParticle 15s ease-in-out infinite alternate;
}

.particle:nth-child(1) {
  top: 20%;
  left: 10%;
}

.particle:nth-child(2) {
  top: 40%;
  right: 15%;
  width: 4px;
  height: 4px;
  animation-delay: 2s;
  animation-duration: 20s;
}

.particle:nth-child(3) {
  bottom: 30%;
  left: 30%;
  width: 5px;
  height: 5px;
  animation-delay: 4s;
  animation-duration: 18s;
}

.particle:nth-child(4) {
  top: 70%;
  right: 30%;
  width: 8px;
  height: 8px;
  animation-delay: 6s;
  animation-duration: 22s;
}

.particle:nth-child(5) {
  top: 15%;
  right: 40%;
  width: 3px;
  height: 3px;
  animation-delay: 8s;
  animation-duration: 25s;
}

.particle:nth-child(6) {
  bottom: 20%;
  right: 10%;
  width: 7px;
  height: 7px;
  animation-delay: 10s;
  animation-duration: 16s;
}

.cta-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
}

.gradient-blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.15;
}

.blob-1 {
  width: 800px;
  height: 800px;
  background: radial-gradient(circle, rgba(157, 110, 253, 1) 0%, rgba(157, 110, 253, 0) 70%);
  top: -400px;
  right: -200px;
  animation: moveBlob 25s ease-in-out infinite alternate;
}

.blob-2 {
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(232, 121, 249, 1) 0%, rgba(232, 121, 249, 0) 70%);
  bottom: -300px;
  left: -100px;
  animation: moveBlob 30s ease-in-out 5s infinite alternate-reverse;
}

@keyframes pulseCore {
  0% {
    transform: scale(1);
    box-shadow: 0 0 30px rgba(157, 110, 253, 0.6);
  }
  100% {
    transform: scale(1.1);
    box-shadow: 0 0 50px rgba(157, 110, 253, 0.8);
  }
}

@keyframes rotateRing {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes orbitParticle {
  0% {
    transform: translate(0, 0) scale(1);
  }
  25% {
    transform: translate(20px, 20px) scale(1.2);
  }
  50% {
    transform: translate(0, 40px) scale(1);
  }
  75% {
    transform: translate(-20px, 20px) scale(0.8);
  }
  100% {
    transform: translate(0, 0) scale(1);
  }
}

@keyframes floatParticle {
  0% {
    transform: translate(0, 0);
    opacity: 0.3;
  }
  50% {
    transform: translate(20px, 20px);
    opacity: 0.8;
  }
  100% {
    transform: translate(-20px, -20px);
    opacity: 0.3;
  }
}

@keyframes moveBlob {
  0% {
    transform: translate(0, 0) scale(1);
  }
  50% {
    transform: translate(50px, -50px) scale(1.1);
  }
  100% {
    transform: translate(-50px, 50px) scale(0.9);
  }
}

@media screen and (max-width: 992px) {
  .cta-container {
    flex-direction: column;
    gap: 3rem;
  }
  
  .cta-content {
    max-width: 100%;
    text-align: center;
  }
  
  .cta-title {
    font-size: 2.5rem;
  }
  
  .cta-actions {
    justify-content: center;
  }
  
  .advantage-chips {
    justify-content: center;
  }
  
  .tech-sphere {
    transform: scale(0.9);
  }
}

@media screen and (max-width: 768px) {
  .cta-section {
    padding: 5rem 0;
  }
  
  .cta-title {
    font-size: 2rem;
  }
  
  .cta-description {
    font-size: 1rem;
  }
  
  .tech-sphere {
    transform: scale(0.8);
  }
}

@media screen and (max-width: 576px) {
  .cta-title {
    font-size: 1.75rem;
  }
  
  .cta-actions {
    flex-direction: column;
  }
  
  .button {
    width: 100%;
    padding: 0.9rem 1.5rem;
  }
  
  .tech-sphere {
    transform: scale(0.7);
  }
}
</style> 